import { render, staticRenderFns } from "./company-form-token.vue?vue&type=template&id=29a5fe96"
import script from "./company-form-token.vue?vue&type=script&lang=js"
export * from "./company-form-token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports